module.exports = __webpack_public_path__ + "media/images/weather/300_night-0f528c13f096129e0af982200e8e6461.png";